import { NAVER_CLIENT_ID, LOGIN_REDIRECT_URI } from "../Config";

export const getNaverLoginUrl= () => {
    const params = new URLSearchParams({
        client_id: process.env.REACT_APP_NAVER_CLIENT_ID,
        redirect_uri: `${LOGIN_REDIRECT_URI}/naver`,
        response_type: "code",
        auth_type: "reprompt"
    });

    return `https://nid.naver.com/oauth2.0/authorize?${params.toString()}`;
}